import React, { useState } from 'react';
import CustomImageLightbox from './CustomImageLightbox';

export default function ModalImage({
    small,
    large,
    alt = "wisetech",
    className = "",
    imageArray,
    currentIndex,
    ...props
}) {
    const [isOpen, setIsOpen] = useState(false);

    // If an imageArray is provided, we use it. Otherwise, we default to a single-image array.
    const images = imageArray && imageArray.length > 0 ? imageArray : [large || small];
    const startIndex = currentIndex !== undefined && currentIndex >= 0 ? currentIndex : 0;

    return (
        <>
            <img
                src={small}
                alt={alt}
                className={className}
                onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(true);
                }}
                style={{ cursor: 'pointer' }}
                {...props}
            />
            {isOpen && (
                <CustomImageLightbox
                    images={images}
                    startIndex={startIndex}
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    alt={alt}
                />
            )}
        </>
    );
}
